<script lang="ts">
  import Info from "../../components/info.svelte";

  export let data;

  $: hero = data.settings.hero;
  $: whiteLabel = data.whiteLabel;
</script>

<main>
  <Info {hero} {whiteLabel} />
</main>

<style>
  main {
    flex: 1 1 auto;
    hyphens: auto;
    overflow: auto;
    width: 100%;
  }
</style>
